import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'search',
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], key: string, search: string, key2: string = null, key3: string = null): any[] {

    if (items) {

      if (search) {

        items = items.filter((item) => {
          const keysToSearch = [key, key2, key3].filter(Boolean);

          return keysToSearch.some((k) => {
            if (item[k]) {
              return item[k].toString().toLowerCase().includes(search.toLowerCase());
            }
          });

        });

      }

      return items;
    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/search/search.ts